import DirectInterestInANaturalResourcesAssetForm from "./DirectInterestInANaturalResourcesAssetForm";

export default DirectInterestInANaturalResourcesAssetForm;
